export default [
	{
		path: '/app/user/register',
		component: () => import('../../../layouts/UnauthLayout.vue'), // 使用するレイアウトの選択
		children: [
			{
				path: '', // 親と同じpathで表示するコンポーネントを下記で指定
				name: 'userRegister',
				component: () => import(/* webpackChunkName: "dashboard" */ '../../../components/user/RegisterView'),
				meta: { title:'YubiOn SecureFileTransfer | Registration'}
			},
		]
	},
	{
		path: '/app/user',
		component: () => import('../../../layouts/MainLayout.vue'), // 使用するレイアウトの選択
		children: [
			{
				path: 'confirm/:key', // 親と同じpathで表示するコンポーネントを下記で指定
				name: 'userConfirm',
				component: () => import(/* webpackChunkName: "dashboard" */ '../../../components/user/ConfirmView'),
				meta: { title:'YubiOn SecureFileTransfer | Mail confirmation'}
			},
			{
				path: 'activate/:key', // 親と同じpathで表示するコンポーネントを下記で指定
				name: 'userActivate',
				component: () => import(/* webpackChunkName: "dashboard" */ '../../../components/user/ActivateView'),
				meta: { title:'YubiOn SecureFileTransfer | Mail confirmation'}
			},
			{
				path: 'settings', // 親と同じpathで表示するコンポーネントを下記で指定
				name: 'userSettings',
				component: () => import(/* webpackChunkName: "dashboard" */ '../../../components/user/SettingsView'),
				meta: { title:'YubiOn SecureFileTransfer | User settings'}
			},
			{
				path: 'unsubscription', // 親と同じpathで表示するコンポーネントを下記で指定
				name: 'unsubscription',
				component: () => import(/* webpackChunkName: "dashboard" */ '../../../components/user/UnsubscriptionView'),
				meta: { title:'YubiOn SecureFileTransfer | Unsubscription'}
			},
		]
	},
	{
		path: '/app/user',
		component: () => import('../../../layouts/UnauthLayout.vue'), // 使用するレイアウトの選択
		children: [
			{
				path: 'unsubscriptionComplete', // 親と同じpathで表示するコンポーネントを下記で指定
				name: 'unsubscriptionComplete',
				component: () => import(/* webpackChunkName: "dashboard" */ '../../../components/user/UnsubscriptionCompleteView'),
				meta: { title:'YubiOn SecureFileTransfer | Unsubscription Complete'}
			},
		]
	}
]
